var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopySquareGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#1D314C",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 15,
    height: 15,
    rx: 3.5,
    stroke: "#1D314C",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 8.91667V8.5C6.75 8.16848 6.8817 7.85054 7.11612 7.61612C7.35054 7.3817 7.66848 7.25 8 7.25H8.41667V5.8625C8.41667 5.78846 8.38725 5.71745 8.3349 5.6651C8.28255 5.61275 8.21154 5.58333 8.1375 5.58333H5.3625C5.28846 5.58333 5.21745 5.61275 5.1651 5.6651C5.11275 5.71745 5.08333 5.78846 5.08333 5.8625V8.6375C5.08333 8.71154 5.11275 8.78255 5.1651 8.8349C5.21745 8.88725 5.28846 8.91667 5.3625 8.91667H6.75ZM6.75 9.75H5.3625C5.06778 9.7489 4.78545 9.63134 4.57706 9.42294C4.36866 9.21455 4.2511 8.93222 4.25 8.6375V5.8625C4.2511 5.56778 4.36866 5.28545 4.57706 5.07706C4.78545 4.86866 5.06778 4.7511 5.3625 4.75H8.1375C8.43222 4.7511 8.71455 4.86866 8.92294 5.07706C9.13134 5.28545 9.2489 5.56778 9.25 5.8625V7.25H10.5C10.8315 7.25 11.1495 7.3817 11.3839 7.61612C11.6183 7.85054 11.75 8.16848 11.75 8.5V11C11.75 11.3315 11.6183 11.6495 11.3839 11.8839C11.1495 12.1183 10.8315 12.25 10.5 12.25H8C7.66848 12.25 7.35054 12.1183 7.11612 11.8839C6.8817 11.6495 6.75 11.3315 6.75 11V9.75ZM7.70537 8.20537C7.78351 8.12723 7.88949 8.08333 8 8.08333H10.5C10.6105 8.08333 10.7165 8.12723 10.7946 8.20537C10.8728 8.28351 10.9167 8.38949 10.9167 8.5V11C10.9167 11.1105 10.8728 11.2165 10.7946 11.2946C10.7165 11.3728 10.6105 11.4167 10.5 11.4167H8C7.88949 11.4167 7.78351 11.3728 7.70537 11.2946C7.62723 11.2165 7.58333 11.1105 7.58333 11V8.5C7.58333 8.38949 7.62723 8.28351 7.70537 8.20537Z",
    fill: "#1D314C",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySquareGrey);
export default __webpack_public_path__ + "static/media/copy-square-grey.40844ce6.svg";
export { ForwardRef as ReactComponent };